<template>
  <div>
    <div class="py-4 py-md-3 bg-white shadow-sm">
      <div class="container text-center position-relative">
        <router-link :to="`${url}/acompanhar/${id_pedido}`" class="btn btn-outline-light btn-voltar-round position-absolute" style="left: 12px; top: -9px" aria-label="Voltar">
          <i class="fa fa-chevron-left text-dark"></i>
        </router-link>
        <h1 class="h6 font-weight-bold m-auto">PAGAMENTO</h1>
      </div>
    </div>
    <div style="height: 100%" v-if="load">
      <loading fullscrean="true"/>
    </div>
    <div class="container pt-3" v-show="!load" style="max-width: 600px">
      <pix-pagamento ref="modalPix" :empresa="empresa" @confirmar="confirmarPagamento" @atualizar="buscarPedido" @cancelar="cancelar"/>
    </div>
  </div>
</template>

<script>
import Loading from '../components/Loading'
import PixPagamento from "../components/PixPagamento";

export default {
  name: 'PagamentoApp',
  components: {PixPagamento, Loading },
  data() {
    return {
      token: localStorage.getItem('token'),
      id_pedido: null,
      load: true,
      dados: null,
      url: '',
      syncTimeout: null
    }
  },

  methods: {
    buscarPedido() {
      const url = this.$helpers.base_url(this, this.empresa);
      this.load = true;

      this.$http.get(url + this.token + '/pedido/pagamento?id_pedido=' + this.id_pedido)
        .then(response => {
          this.load = false;
          const id_pedido = response.data?.id_pedido || null;
          const pedido = id_pedido ? response.data : null;

          if (!id_pedido || parseInt(pedido.previsao_pagamento || '0') < 0) {
            this.cancelar();
            return;
          }

          switch (response.data?.status_pagamento) {
            case '1':
              this.pollingPedido();
              this.$refs.modalPix.openPagamento(pedido);
              break;

            default:
              this.stopPolling();
              this.$router.push(this.url + `/acompanhar/${id_pedido}`);
              break;
          }

        }, res => {
          this.load = false;
          if (res.status === 401 && res.data.result !== '') {
            this.$swal(res.data.result + ' ' + res.data.msg).then(() => {
              this.$store.commit('logout');
              this.$router.push(this.url + '/perfil');
            });
          }
        });
    },

    pollingPedido() {
      this.stopPolling();

      if (!this.usuario?.id_cliente) {
        return;
      }

      this.syncTimeout = setTimeout(() => {
        this.$http.get(`${this.server}polling-pedidos?id_cliente=${this.usuario.id_cliente}`)
          .then(response => {
            if ((response.data || {}).success) {
              this.buscarPedido();
            }
          }, () => {
            // segue tentando no proximo ciclo
          });

        this.pollingPedido();
      }, 15000);
    },

    stopPolling() {
      if (this.syncTimeout) {
        clearTimeout(this.syncTimeout);
        this.syncTimeout = null;
      }
    },

    confirmarPagamento(payment_id, id_pedido) {
      this.load = true;

      this.$http.post(this.server + "confirmar-pagamento", { payment_id, id_pedido })
        .then(res => {
          this.load = false;

          if (res.data.result) {
            const empresa = res.data.empresa;
            const msg = res.data.whatsapp;

            if (msg && empresa?.whatsapp) {
              const msgZap = window.encodeURIComponent(msg);
              const titulo = "Pagamento confirmado com sucesso. Você será encaminhado para o WhatsApp, envie sem editar a mensagem para que possamos receber e aceitar seu pedido!";

              this.$swal(titulo).then(() => {
                window.location.assign("https://api.whatsapp.com/send?phone=55" + empresa.whatsapp + "&text=" + msgZap);
              });

            } else {
              this.$router.push(this.url + `/acompanhar/${id_pedido}`);
            }

          } else {
            this.$swal(res.data?.msg || 'Erro temporário');
          }

          this.buscarPedido();

        }, res => {
          this.load = false;
          this.$swal(res.data?.msg || 'Erro temporário');
        });
    },

    cancelar() {
      this.stopPolling();
      this.$router.push(this.url + '/acompanhar/' + this.id_pedido);
    },

    handleVisibilityChange() {
      if (document.hidden) {
        this.stopPolling();

      } else {
        this.buscarPedido();
      }
    }
  },

  mounted() {
    this.url = this.$helpers.getUrlApp(this.$route.params.id || '');
    this.id_pedido = this.$route.params.pedido || null;

    if (!this.id_pedido) {
      // redirecioanar meus pedidos
      this.$router.push(this.url + '/pedidos');
      return;
    }

    if (this.token) {
      document.addEventListener("visibilitychange", this.handleVisibilityChange);

      if (this.$route.query.payment_id && this.$route.query.external_reference) {        
        this.confirmarPagamento(this.$route.query.payment_id, this.$route.query.external_reference);

      } else {
        this.buscarPedido();
      }

    } else {
      this.load = false;
    }
  },

  beforeDestroy() {
    this.stopPolling();
    document.removeEventListener("visibilitychange", this.handleVisibilityChange);
  },

  computed: {
    empresa() {
      return this.$store.state.empresa
    },

    usuario() {
      return this.$store.state.dataUser
    }
  }
}
</script>

<style scoped>
</style>
